<template>
  <v-card class="mx-auto" :loading="loading" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" md="8">
          <BtnCircle
            tLabel="Atrás"
            tPosition="bottom"
            icon="mdi-arrow-left"
            color="grey darken-3"
            size="x-small"
            :to="{ name: page_route }"
          />
          <span
            class="text-h6 ml-1"
            v-text="`${$route.meta.title} | IDP ${id}`"
          />
        </v-col>

        <v-col v-if="data" cols="12" md="4" class="text-right">
          <!-- Ayuda -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="info"
                @click.stop="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>

          <!-- Revisión -->
          <v-tooltip v-if="login.permissions.providers.update" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                :color="data.revision_date ? '' : 'warning'"
                @click.prevent="revisionDlgOpen"
              >
                <v-icon>mdi-file-certificate</v-icon>
              </v-btn>
            </template>
            <span
              >Revisión {{ data.revision_date ? data.revision_date : "" }}</span
            >
          </v-tooltip>

          <!-- Término convenio -->
          <v-tooltip
            v-if="!data.active && login.permissions.providers.update"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                :color="data.end_agreement ? '' : 'warning'"
                @click.prevent="endAgreementDlgOpen"
              >
                <v-icon>mdi-calendar-export</v-icon>
              </v-btn>
            </template>
            <span v-text="'Término de convenio'" />
          </v-tooltip>

          <!-- Editar -->
          <BtnCircle
            v-if="data.active && login.permissions.providers.update"
            tLabel="Editar"
            tPosition="bottom"
            icon="mdi-pencil"
            color="info"
            size="x-small"
            :to="{ name: `${page_route}.update`, params: { id: id } }"
          />
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text v-if="data && data.id">
      <v-row>
        <!-- ALERTA REV -->
        <v-col v-if="!data.rev_passed" cols="12">
          <v-alert
            dense
            outlined
            text
            shaped
            :type="data.rev_passed == null ? 'warning' : 'error'"
          >
            <v-row dense>
              <v-col class="grow">
                {{
                  data.rev_passed == null
                    ? "Pendiente de revisión"
                    : `Rechazado por revisión de ${data.rev_by.email} | ${data.rev_at}`
                }}
              </v-col>

              <v-col
                v-if="
                  login.permissions.providers_revs.update &&
                    data.rev_passed == null &&
                    data.updated_by_id != login.id
                "
                class="shrink"
              >
                <v-btn x-small color="success" @click="revDlgOpen"
                  >Revisar</v-btn
                >
              </v-col>
            </v-row>
          </v-alert>
        </v-col>

        <!-- GENERAL -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <span class="text-caption" v-text="'GENERAL'" />
              <v-icon small :color="data.active ? 'success' : 'error'"
                >mdi-circle</v-icon
              >
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4">
                  <ViewData label="Nombre" :value="data.name" />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData
                    label="Nombre de comercial"
                    :value="data.trade_name"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData
                    label="Tipo de proveedor"
                    :value="data.provider_type.provider_type"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Concentrador"
                    :value="
                      data.provider_brand_id
                        ? data.provider_brand.provider_brand
                        : 'NINGUNO'
                    "
                    :alert="!data.provider_brand_id"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    data.provider_type_id === 4 && data.status_account_format
                  "
                >
                  <ViewData
                    label="Formato de estado de cuenta"
                    :value="data.status_account_format.status_account_format"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Provider Type"
                    :value="
                      data.provider_type_detail
                        ? data.provider_type_detail.name
                        : null
                    "
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Provider Specialty"
                    :value="
                      data.provider_specialty
                        ? data.provider_specialty.name
                        : null
                    "
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData label="IP" :value="data.ip ? 'SI' : 'NO'" />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData label="OP" :value="data.op ? 'SI' : 'NO'" />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Usuario sistema"
                    :value="data.user && data.user.active ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col v-if="data.user && data.user.active" cols="12" md="4">
                  <ViewData
                    label="Correo electrónico"
                    :value="data.user.email2"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData label="RFC" :value="data.code_tax" />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Evidencia (PDF)"
                    :value="data.proof_0 ? null : '-'"
                  />
                  <v-btn
                    v-if="data.proof_0"
                    x-small
                    fab
                    outlined
                    class="mr-1"
                    color="warning"
                    :href="getDocUrl(data.proof_0)"
                    target="_blank"
                  >
                    <v-icon v-text="'mdi-download'" />
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <ViewData
                    label="Observación"
                    :value="data.observation"
                    :alert="!!data.observation"
                  />
                </v-col>

                <template v-if="data.end_agreement">
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <ViewData
                      label="Término convenio"
                      :value="data.end_agreement"
                    />
                  </v-col>
                  <v-col cols="12" md="9">
                    <ViewData
                      label="Observación"
                      :value="data.end_agreement_observation"
                    />
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TIPO DE PROVEEDOR -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption" v-text="'TIPO DE PROVEEDOR'" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(ppt, i) in data.provider_provider_types"
                  :key="i"
                >
                  <v-row dense>
                    <v-col cols="12">
                      <ViewData
                        label="Tipo"
                        :value="ppt.provider_type.provider_type"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- BANCO -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption" v-text="'BANCO'" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4">
                  <ViewData
                    label="Nombre"
                    :value="data.bank_id ? data.bank.bank : 'PENDIENTE'"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData
                    label="Número de cuenta"
                    :value="data.account_number"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData label="CLABE" :value="data.clabe" />
                </v-col>
                <v-col cols="12" md="4">
                  <ViewData
                    label="Descuento"
                    :value="data.discount ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Cuenta bancaria (PDF)"
                    :value="data.bank_account_pdf ? null : '-'"
                  />
                  <v-btn
                    v-if="data.bank_account_pdf"
                    x-small
                    fab
                    outlined
                    class="mr-1"
                    color="warning"
                    :href="getDocUrl(data.bank_account_pdf)"
                    target="_blank"
                  >
                    <v-icon v-text="'mdi-download'" />
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4">
                  <ViewData
                    label="Valid. cuenta (PDF)"
                    :value="data.account_validation_pdf ? null : '-'"
                  />
                  <v-btn
                    v-if="data.account_validation_pdf"
                    x-small
                    fab
                    outlined
                    class="mr-1"
                    color="warning"
                    :href="getDocUrl(data.account_validation_pdf)"
                    target="_blank"
                  >
                    <v-icon v-text="'mdi-download'" />
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- DOMICILIO -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption" v-text="'DOMICILIO'" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3"
                  ><ViewData label="Calle" :value="data.street"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData
                    label="Número exterior"
                    :value="data.external_number"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData
                    label="Número interior"
                    :value="data.internal_number"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Colonia" :value="data.suburb"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Estado" :value="data.entity"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Municipio" :value="data.municipality"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Código postal" :value="data.zip"
                /></v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Comp. domicilio (PDF)"
                    :value="data.proof_address_pdf ? null : '-'"
                  />
                  <v-btn
                    v-if="data.proof_address_pdf"
                    x-small
                    fab
                    outlined
                    color="warning"
                    :href="getDocUrl(data.proof_address_pdf)"
                    target="_blank"
                  >
                    <v-icon v-text="'mdi-download'" />
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- LEGAL -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption" v-text="'LEGAL'" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3"
                  ><ViewData label="Razón social" :value="data.legal_name"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData
                    label="Domicilio fiscal"
                    :value="data.legal_address"
                /></v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="RFC (PDF)"
                    :value="data.code_tax_pdf ? null : '-'"
                  />
                  <v-btn
                    v-if="data.code_tax_pdf"
                    x-small
                    fab
                    outlined
                    class="mr-1"
                    color="warning"
                    :href="getDocUrl(data.code_tax_pdf)"
                    target="_blank"
                  >
                    <v-icon v-text="'mdi-download'" />
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- CONTACTO -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption" v-text="'CONTACTO'"
            /></v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="6"
                  ><ViewData
                    label="Nombre de contacto"
                    :value="data.contact_name"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Ext. pais (+)" :value="data.phone_ext"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Teléfono" :value="data.phone"
                /></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- OTROS -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption" v-text="'OTROS'"
            /></v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3"
                  ><ViewData label="IVA" :value="data.iva"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Día de pago" :value="data.pay_day"
                /></v-col>
                <v-col cols="12" md="3"
                  ><ViewData label="Factor CPT" :value="data.cpt_factor"
                /></v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="NET ID"
                    :value="data.net_id || ''"
                    :alert="!data.net_id"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Descuento en factura"
                    :value="data.bill_discount ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Tipo de descuento"
                    :value="getDiscountLabel(data.fixed_discount)"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Porcentaje de descuento"
                    :value="data.fund_without_discount"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Formato DDC en factura"
                    :value="data.ddc_format ? data.ddc_format : 'NINGUNO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Nota de crédito posterior"
                    :value="data.credit_note_after ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Descuento, deducible y coaseguro"
                    :value="data.ddc ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Monto exento"
                    :value="data.exempt_amount ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="IVA, deducible y coaseguro"
                    :value="data.idc ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Convenio"
                    :value="data.agreement ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Segunda firma red"
                    :value="data.revision ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData label="C.S." :value="data.cs" :alert="!data.cs" />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Sumar deducible y coseguro"
                    :value="data.add_deductible_coinsurance ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="No verificar monto nota de crédito"
                    :value="data.notes_verify_amount ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Aumento de suma automático"
                    :value="data.automatic_authorization ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Porc. cobro particulares"
                    :value="data.particular_payment"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Envío correos cobro particulares"
                    :value="data.service_particular_email ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Generar carta servicio automáticamente"
                    :value="data.auto_letter_generated ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Módulo SM"
                    :value="data.with_module ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Auto confirmar servicios"
                    :value="data.rs_service_auto_confirm ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <ViewData
                    label="Pase para servicios"
                    :value="data.has_service_pass ? 'SI' : 'NO'"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- INFO | REVISIÓN DE CARTERA -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption" v-text="'INFO | REVISIÓN DE CARTERA'" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3">
                  <ViewData
                    label="Mostrar mensaje"
                    :value="data.show_collection_review_message ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col v-if="data.show_collection_review_message" cols="12">
                  <ViewData
                    label="Mensaje"
                    :value="data.collection_review_message"
                    :alert="!!data.collection_review_message"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- CONDICIONES HOSPITALES SEDE -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2 class="text-caption">CONDICIONES HOSPITALES SEDE</h2>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3">
                  <ViewData
                    label="Activo"
                    :value="data.express_letter ? 'SI' : 'NO'"
                  />
                </v-col>

                <v-col v-if="data.express_letter" cols="12" md="3">
                  <ViewData
                    label="Monto"
                    :value="moneyFormat(data.express_amount)"
                  />
                </v-col>

                <v-col v-if="data.express_letter" cols="12">
                  <ViewData label="Observación" :value="data.express_caption" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- FACTURAS -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption" v-text="'FACTURAS'"
            /></v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(item, i) in data.invoices_receptions"
                  :key="i"
                >
                  <v-row v-if="item.active" dense>
                    <v-col cols="12" md="5">
                      <ViewData
                        :label="`Día de recepción (${i + 1})`"
                        :value="item.day.day"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <ViewData label="Hora de inicio" :value="item.start" />
                    </v-col>
                    <v-col cols="12" md="4">
                      <ViewData label="Hora de término" :value="item.end" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- EMAILS -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h2
                class="text-caption"
                v-text="'ENVÍO DE CORREOS ELECTRÓNICOS'"
              />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(provider_email, i) in data.provider_emails"
                  :key="i"
                >
                  <v-row v-if="provider_email.active" dense>
                    <v-col cols="5">
                      <ViewData
                        :label="`Correo electrónico (${i + 1})`"
                        :value="provider_email.email"
                      />
                    </v-col>
                    <v-col cols="5">
                      <ViewData
                        label="Uso"
                        :value="
                          provider_email.for_service
                            ? 'Servicio particular'
                            : 'Carta ingresos'
                        "
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- ASEGURADORAS -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption">ASEGURADORAS</h2></v-card-title
            >
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(pi, i) in data.provider_insurances"
                  :key="i"
                >
                  <v-row v-if="pi.active" dense>
                    <v-col cols="5">
                      <ViewData
                        :label="`Aseguradora (${i + 1})`"
                        :value="pi.insurance.name"
                      />
                    </v-col>
                    <v-col cols="3">
                      <ViewData
                        label="INFO Reporte Ing., Urg. y Serv."
                        :value="pi.show_rhas ? 'SI' : 'NO'"
                      />
                    </v-col>
                    <v-col cols="4">
                      <ViewData
                        label="INFO Facturación"
                        :value="pi.show_bills ? 'SI' : 'NO'"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- CONCENTRADOR -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption">CONCENTRADOR</h2></v-card-title
            >
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(provider_in_group, i) in data.provider_in_groups"
                  :key="i"
                >
                  <v-row v-if="provider_in_group.active" dense>
                    <v-col cols="6">
                      <ViewData
                        :label="`Nombre (${i + 1})`"
                        :value="provider_in_group.provider_group"
                      />
                    </v-col>
                    <v-col cols="6">
                      <ViewData
                        label="APT = Alta Apertura Terminada"
                        :value="
                          provider_in_group.opening_discharge ? 'SI' : 'NO'
                        "
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- REGISTRO -->
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title
              ><h2 class="text-caption" v-text="'REGISTRO'"
            /></v-card-title>
            <v-divider />
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="6">
                  <ViewData
                    label="Creación"
                    :value="data.created_by.email"
                    :subvalue="data.created_at"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <ViewData
                    label="U. actualización"
                    :value="data.updated_by.email"
                    :subvalue="data.updated_at"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- ACCIONES -->
        <v-col cols="12">
          <BtnCircle
            v-if="login.permissions.providers.delete && data.active"
            tLabel="Desactivar"
            tPosition="top"
            icon="mdi-delete"
            color="error"
            size="x-small"
            :click="handleDeactivate"
            :loading="loading"
          />

          <v-tooltip
            v-if="login.permissions.providers.update && !data.active"
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                color="warning"
                @click.prevent="restore"
              >
                <v-icon>mdi-delete-restore</v-icon>
              </v-btn>
            </template>
            <span v-text="'Activar'" />
          </v-tooltip>

          <v-tooltip v-if="login.permissions.providers_assign.update" right>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                color="pink"
                dark
                class="ml-1"
                :to="{ name: 'providers.assign', params: { id: id } }"
              >
                <v-icon>mdi-update</v-icon>
              </v-btn>
            </template>
            <span v-text="'Asignar'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />

    <!-- DLG: END AGREEMENT -->
    <v-dialog
      v-model="end_agreement_dlg"
      scrollable
      persistent
      max-width="450px"
    >
      <v-card tile :disabled="end_agreement_ldg" :loading="end_agreement_ldg">
        <v-toolbar dark dense>
          <v-toolbar-title>REGISTRAR</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="end_agreement_dlg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-if="end_agreement_data">
          <v-form v-on:submit.prevent ref="end_agreement_form" lazy-validation>
            <v-row dense class="pt-5">
              <v-col cols="12">
                <DatePicker
                  label="Término convenio"
                  :model.sync="end_agreement_data.end_agreement"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="end_agreement_data.end_agreement_observation"
                  label="Observación"
                  dense
                  rows="2"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  dark
                  small
                  color="warning"
                  @click.prevent="endAgreementSubmit"
                >
                  Continuar
                  <v-icon small right>mdi-calendar-export</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DLG: REVISION -->
    <v-dialog v-model="revision_dlg" scrollable persistent max-width="450px">
      <v-card tile :disabled="revision_ldg" :loading="revision_ldg">
        <v-toolbar dark dense>
          <v-toolbar-title>REVISIÓN</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="revision_dlg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-if="revision_data">
          <v-form v-on:submit.prevent ref="revision_form" lazy-validation>
            <v-row dense class="pt-5">
              <v-col cols="12">
                <DatePicker
                  label="Fecha"
                  :model.sync="revision_data.revision_date"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="revision_data.revision_observation"
                  label="Observación"
                  dense
                  rows="2"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  dark
                  small
                  color="warning"
                  @click.prevent="revisionSubmit"
                >
                  Continuar
                  <v-icon small right>mdi-check</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DLG: REV PASSED -->
    <v-dialog v-model="rev_dlg" scrollable persistent max-width="380px">
      <v-card :loading="rev_ldg" :disabled="rev_ldg" tile>
        <v-toolbar dark dense>
          <v-toolbar-title>Revisión</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="rev_dlg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-if="rev">
          <v-row dense class="pt-4">
            <v-col cols="6">
              <v-btn small block color="error" @click.prevent="revSubmit(false)"
                >Rechazar</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                small
                block
                color="success"
                @click.prevent="revSubmit(true)"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  msgConfirm,
  msgAlert,
  URL_DOCUMENTS,
  dateTimeNow,
  rules,
} from "../../control";
import { show, destroy } from "../../requests/pageRequest";
import BtnCircle from "../../components/BtnCircle.vue";
import ViewData from "../../components/ViewData.vue";
import FaqDlg from "../../components/FaqDlg.vue";
import DatePicker from "../../components/DatePicker.vue";

export default {
  components: {
    BtnCircle,
    ViewData,
    FaqDlg,
    DatePicker,
  },

  data() {
    return {
      page_route: "providers",
      id: Number(this.$route.params.id),
      login: this.$store.getters.getLogin,

      loading: true,
      rules: rules(),
      url_documents: URL_DOCUMENTS,

      discounts: [
        { id: 0, discount: "Variable" },
        { id: 1, discount: "Fijo" },
      ],

      data: null,

      // dialogs
      end_agreement_data: null,
      end_agreement_dlg: false,
      end_agreement_ldg: true,

      revision_data: null,
      revision_dlg: false,
      revision_ldg: true,

      rev: null,
      rev_dlg: false,
      rev_ldg: false,

      // faqs
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },

  methods: {
    // --------
    // Helpers
    // --------
    getDocUrl(file) {
      return `${this.url_documents}/providers/${file}`;
    },

    getDiscountLabel(fixed_discount) {
      const id = Number(fixed_discount);
      const found = this.discounts.find((d) => d.id === id);
      return found ? found.discount : null;
    },

    moneyFormat(v) {
      const n = Number(v || 0);
      return Number(n.toFixed(2)).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    // --------
    // Data
    // --------
    async getItem() {
      this.loading = true;

      try {
        const rsp = await show(this.page_route, this.login.token, this.id);
        this.data = rsp;
      } finally {
        this.loading = false;
      }
    },

    // --------
    // Actions
    // --------
    handleDeactivate() {
      this.$swal
        .fire(msgConfirm("¿Confirma la desactivación del registro?"))
        .then(async (rsp) => {
          if (!rsp.isConfirmed) return;

          this.loading = true;

          try {
            const res = await destroy(
              this.page_route,
              this.login.token,
              this.id,
              this.login.id,
            );

            this.$swal.fire(
              msgAlert(res.success ? "success" : "error", res.message),
            );

            if (res.success) {
              this.$router.push({ name: this.page_route });
            } else {
              console.log(res.message);
              this.loading = false;
            }
          } catch (e) {
            console.log(e);
            this.$swal.fire(
              msgAlert("error", "Error. Contacte al equipo de desarrollo"),
            );
            this.loading = false;
          }
        });
    },

    restore() {
      this.$swal
        .fire(msgConfirm("¿Confirma activar el registro?"))
        .then((rsp) => {
          if (!rsp.isConfirmed) return;

          this.loading = true;

          Axios.post(
            `${URL_API}/providers/restore`,
            { id: this.data.id },
            headersToken(this.login.token),
          )
            .then((resp) => {
              this.$swal.fire(
                msgAlert(
                  resp.data.success ? "success" : "error",
                  resp.data.message,
                ),
              );

              if (resp.data.success) this.getItem();
            })
            .catch((e) => {
              console.log(e);
              this.$swal.fire(
                msgAlert("error", "Error. Contacte al equipo de desarrollo"),
              );
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },

    // --------
    // Dialogs
    // --------
    endAgreementDlgOpen() {
      this.end_agreement_data = {
        id: this.data.id,
        end_agreement: dateTimeNow().substring(0, 10),
        end_agreement_observation: "",
      };

      this.end_agreement_ldg = false;
      this.end_agreement_dlg = true;
    },

    endAgreementSubmit() {
      if (!this.$refs.end_agreement_form.validate()) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );
        return;
      }

      this.$swal
        .fire(msgConfirm("¿Confirma registrar información?"))
        .then((rsp) => {
          if (!rsp.isConfirmed) return;

          this.end_agreement_ldg = true;

          Axios.post(
            `${URL_API}/providers/end_agreement`,
            this.end_agreement_data,
            headersToken(this.login.token),
          )
            .then((resp) => {
              this.$swal.fire(
                msgAlert(
                  resp.data.success ? "success" : "error",
                  resp.data.message,
                ),
              );

              if (resp.data.success) {
                this.end_agreement_dlg = false;
                this.getItem();
              }
            })
            .catch((e) => {
              console.log(e);
              this.$swal.fire(
                msgAlert("error", "Error. Contacte al equipo de desarrollo"),
              );
            })
            .finally(() => {
              this.end_agreement_ldg = false;
            });
        });
    },

    revisionDlgOpen() {
      this.revision_data = {
        id: this.data.id,
        revision_date: this.data.revision_date
          ? this.data.revision_date
          : dateTimeNow().substring(0, 10),
        revision_observation: this.data.revision_observation || "",
      };

      this.revision_ldg = false;
      this.revision_dlg = true;
    },

    revisionSubmit() {
      if (!this.$refs.revision_form.validate()) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );
        return;
      }

      this.$swal
        .fire(msgConfirm("¿Confirma registrar la revisión?"))
        .then((rsp) => {
          if (!rsp.isConfirmed) return;

          this.revision_ldg = true;

          Axios.post(
            `${URL_API}/providers/revision`,
            this.revision_data,
            headersToken(this.login.token),
          )
            .then((resp) => {
              this.$swal.fire(
                msgAlert(
                  resp.data.success ? "success" : "error",
                  resp.data.message,
                ),
              );

              if (resp.data.success) {
                this.revision_dlg = false;
                this.getItem();
              }
            })
            .catch((e) => {
              console.log(e);
              this.$swal.fire(
                msgAlert("error", "Error. Contacte al equipo de desarrollo"),
              );
            })
            .finally(() => {
              this.revision_ldg = false;
            });
        });
    },

    revDlgOpen() {
      this.rev = { id: this.data.id, rev_passed: null };
      this.rev_ldg = false;
      this.rev_dlg = true;
    },

    revSubmit(rev_passed) {
      this.$swal
        .fire(
          msgConfirm(
            `¿Confirma ${rev_passed ? "ACEPTAR" : "RECHAZAR"} la revisión?`,
          ),
        )
        .then((rsp) => {
          if (!rsp.isConfirmed) return;

          this.rev_ldg = true;
          this.rev.rev_passed = rev_passed;

          Axios.post(
            `${URL_API}/providers/rev`,
            this.rev,
            headersToken(this.login.token),
          )
            .then((resp) => {
              this.$swal.fire(
                msgAlert(
                  resp.data.success ? "success" : "error",
                  resp.data.message,
                ),
              );

              if (resp.data.success) {
                this.getItem();
                this.rev_dlg = false;
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal.fire(
                msgAlert("error", "Error. Contacte al equipo de desarrollo"),
              );
            })
            .finally(() => {
              this.rev_ldg = false;
            });
        });
    },

    // --------
    // FAQ
    // --------
    loadFaqs() {
      Axios.get(
        `${URL_API}/faqs/faq_interfaces/${this.$route.meta.title}`,
        headersToken(this.login.token),
      )
        .then((resp) => {
          this.faqs = resp.data.data || [];
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.faqs_ldg = false;
        });
    },
  },

  mounted() {
    this.getItem();
    this.loadFaqs();
  },
};
</script>
